import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { useTheme } from "../../../Themecontext/Themecontext";
import { useSelector, useDispatch } from 'react-redux';
import { AllFilter, ProdConsRecipeInsert, ProdConsRecipeShowOne, ProdConsRecipeUpdate } from '../../../Redux/Slice/MillstageEntry/MillstageEntrySlice';
import { useLocation, useNavigate } from 'react-router-dom';
import Input from '../../../components/FilterBox/Millstage/Input';
import MillstageDropDownFilter from '../../../components/FilterBox/Millstage/MillstageDropDownFilter';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";


const Treatment = () => {
    const { Colourdata } = useSelector((state) => state.ClientLogin || {});
    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGE");
    const iscolourDark = Colourdata?.data?.find((el) => el.ExeName === "NEWMILLSTAGEDARK");

    const { theme } = useTheme();
    const isdark = theme;
    const dispatch = useDispatch();

    const location = useLocation();
    const navigate = useNavigate();
    const editId = location.state?.id;

    useEffect(() => {
        dispatch(AllFilter());
        if (editId) {
            dispatch(ProdConsRecipeShowOne({ MainID: editId }));
        }
    }, [dispatch, editId]);

    const getCurrentDateKolkata = () => {
        const dateString = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
        const localDate = new Date(dateString);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [formData, setFormData] = useState({
        createDate: getCurrentDateKolkata(),
        recipeCode: "",
        remarks: "",
        partyShadeNo: "",
        isActive: true
    });

    const [rangeVal, setRangeVal] = useState("");
    const [rangeId, setRangeId] = useState(null);
    const [groupVal, setGroupVal] = useState("");
    const [groupId, setGroupId] = useState(null);
    const [partyVal, setPartyVal] = useState("");
    const [partyId, setPartyId] = useState(null);
    const [stageVal, setStageVal] = useState("");
    const [stageId, setStageId] = useState(null);
    const [processVal, setProcessVal] = useState("");
    const [processId, setProcessId] = useState(null);


    const { AllFilterdata, ProdConsRecipeShowOnedata } = useSelector((state) => state.MillstageEntry || {});
    const [isDataPopulated, setIsDataPopulated] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);

    useEffect(() => {
        if (!isDataPopulated && ProdConsRecipeShowOnedata && ProdConsRecipeShowOnedata.Data && ProdConsRecipeShowOnedata.Data.length > 0 && AllFilterdata && Object.keys(AllFilterdata).length > 0) {
            const masterData = ProdConsRecipeShowOnedata.Data[0];

            // Fix "one step behind" bug: Wait until the loaded data matches the editId.
            // Also prevents old Redux data from populating when clicking "New Master" (editId is undefined).
            if (!editId || String(masterData.ProdConsRecipeMstID) !== String(editId)) {
                return;
            }

            const createDate = masterData.CreateDate ? masterData.CreateDate.split('T')[0] : getCurrentDateKolkata();

            setFormData({
                createDate: createDate,
                recipeCode: masterData.RecipeCode || "",
                remarks: masterData.Remarks || "",
                partyShadeNo: masterData.ShadeNo || "",
                isActive: masterData.isActive === 1 || masterData.isActive === true
            });

            const rId = masterData.RangeID || null;
            setRangeId(rId);
            setRangeVal(rId ? AllFilterdata?.Range?.find(x => String(x.RangeId) === String(rId))?.RangeName || "" : "");

            const gId = masterData.ProcessMstId || null;
            setGroupId(gId);
            setGroupVal(gId ? AllFilterdata?.ProcessMst?.find(x => String(x.ProcessMstId) === String(gId))?.ProcessMstName || "" : "");

            const pId = masterData.AcID || null;
            setPartyId(pId);
            setPartyVal(pId ? AllFilterdata?.Party?.find(x => String(x.AcID) === String(pId))?.AcName || "" : "");

            const stId = masterData.TransTypeId || null;
            setStageId(stId);
            setStageVal(stId ? AllFilterdata?.TransType?.find(x => String(x.TransTypeID) === String(stId))?.TTName || "" : "");

            const prId = masterData.ProcessTypeId || masterData.ProcessTypeID || null;
            setProcessId(prId);
            const prItem = AllFilterdata?.ProcessType?.find(x => String(x.ProcessTypeID || x.ProcessTypeId) === String(prId));
            setProcessVal(prItem ? `${prItem?.ProcessType}` : "");


            const newTableData = ProdConsRecipeShowOnedata.Data.map((row, index) => ({
                id: index + 1,
                ProdConsRecipeDtlId: row.ProdConsRecipeDtlId || 0,
                processGroup: row.ItemProcessGroupID || "",
                itemShort: row.ItemId || "",
                item: row.ItemId || "",
                subProcess: row.RecipeSubProcessId || "",
                temp: row.TempNHoldTime || "",
                gpm: row.GramsPerMtr || "",
                weight: row.IsWeightReq === 1 || row.IsWeightReq === true,
                taka: row.IsTakaReq === 1 || row.IsTakaReq === true,
                mts: row.IsQtyReq === 1 || row.IsQtyReq === true,
                liq: row.IsLIQReq === 1 || row.IsLIQReq === true,
                multiplier: row.Multiplier || ""
            }));

            if (newTableData.length > 0) {
                setTableData(newTableData);
            }
            setIsDataPopulated(true);
        }
    }, [ProdConsRecipeShowOnedata, AllFilterdata, isDataPopulated]);

    const rangeList = AllFilterdata?.Range?.map(item => ({ label: item?.RangeName, value: item?.RangeId })) || [];
    const groupList = AllFilterdata?.ProcessMst?.map(item => ({ label: item?.ProcessMstName, value: item?.ProcessMstId })) || [];

    // Filter Party based on selected Group
    const partyList = AllFilterdata?.Party?.filter(item => groupId ? item?.GroupID === groupId : true)?.map(item => ({ label: item?.AcName, value: item?.AcID })) || [];

    const stageTypeList = AllFilterdata?.TransType?.map(item => ({ label: item?.TTName, value: item?.TransTypeID })) || [];

    // Filter Process based on selected Stage Type
    const processList = AllFilterdata?.ProcessType?.filter(item => stageId ? String(item?.TransTypeID || item?.TransTypeId) === String(stageId) : true)?.map(item => ({ label: `${item?.ProcessType}`, value: item?.ProcessTypeID || item?.ProcessTypeId })) || [];

    // Reset dependent dropdowns when parent changes manually
    useEffect(() => {
        if (partyId && groupId) {
            const party = AllFilterdata?.Party?.find(p => String(p.AcID) === String(partyId));
            if (party && String(party.GroupID) !== String(groupId)) {
                setPartyVal("");
                setPartyId(null);
            }
        } else if (!groupId && partyId) {
            setPartyVal("");
            setPartyId(null);
        }
    }, [groupId, partyId, AllFilterdata]);

    useEffect(() => {
        if (processId && stageId) {
            const isValidProcess = AllFilterdata?.ProcessType?.some(p =>
                String(p.ProcessTypeID || p.ProcessTypeId) === String(processId) &&
                String(p.TransTypeID || p.TransTypeId) === String(stageId)
            );
            if (!isValidProcess) {
                setProcessVal("");
                setProcessId(null);
            }
        } else if (!stageId && processId) {
            setProcessVal("");
            setProcessId(null);
        }
    }, [stageId, processId, AllFilterdata]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    // Initialize one empty row for the editable table
    const [tableData, setTableData] = useState([
        { id: 1, ProdConsRecipeDtlId: 0, processGroup: '', itemShort: '', item: '', itemSubGroup: '', subProcess: '', temp: '', gpm: '', weight: false, taka: false, mts: false, liq: false, multiplier: '', cost: '' }
    ]);

    const handleTableChange = (id, field, value) => {
        setTableData(prev => prev.map(row => {
            if (row.id === id) {
                const newRow = { ...row, [field]: value };
                // Keep Item Short and Item in sync
                if (field === 'itemShort') {
                    newRow.item = value;
                } else if (field === 'item') {
                    newRow.itemShort = value;
                }

                // Only one of weight, taka, mts, liq should be true
                if (['weight', 'taka', 'mts', 'liq'].includes(field) && value === true) {
                    newRow.weight = false;
                    newRow.taka = false;
                    newRow.mts = false;
                    newRow.liq = false;
                    newRow[field] = true;
                }

                return newRow;
            }
            return row;
        }));
    };

    const addRow = () => {
        const newId = tableData.length > 0 ? tableData[tableData.length - 1].id + 1 : 1;
        setTableData([...tableData, { id: newId, ProdConsRecipeDtlId: 0, processGroup: '', itemShort: '', item: '', itemSubGroup: '', subProcess: '', temp: '', gpm: '', weight: false, taka: false, mts: false, liq: false, multiplier: '', cost: '' }]);
    };

    const deleteRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };
    const SqlId = Cookies.get('SqlId');

    const handleSave = () => {
        setConfirmAction(editId ? "update" : "save");
        setShowConfirmModal(true);
    };

    const executeSave = () => {
        setShowConfirmModal(false);

        const payload = {
            MainID: editId || "",
            master: {
                CreateDate: formData.createDate ? `${formData.createDate}T00:00:00.000` : "",
                RecipeCode: formData.recipeCode || "",
                RangeID: rangeId || "",
                ProcessMstId: groupId || "",
                AcID: partyId || "",
                TransTypeId: stageId || "",
                ProcessTypeId: processId || "",
                QualityID: "",
                Remarks: formData.remarks || "",
                MatchingId: "",
                ShadeNo: formData.partyShadeNo || "",
                isActive: formData.isActive ? 1 : 0,
                Divident: 1,
                EntryTypeID: 2,
                userId: SqlId
            },
            detail: tableData.map(row => ({
                ProdConsRecipeDtlID: row.ProdConsRecipeDtlId || row.ProdConsRecipeDtlID || 0,
                ItemProcessGroupID: row.processGroup || "",
                ItemId: row.item || "",
                RecipeSubProcessId: row.subProcess || "",
                TempNHoldTime: row.temp || "",
                GramsPerMtr: row.gpm || "",
                IsWeightReq: row.weight ? 1 : 0,
                IsTakaReq: row.taka ? 1 : 0,
                IsQtyReq: row.mts ? 1 : 0,
                IsLIQReq: row.liq ? 1 : 0,
                Multiplier: row.multiplier || "",
                IsMActive: 1
            }))
        };

        if (editId) {
            dispatch(ProdConsRecipeUpdate(payload)).then((res) => {
                if (res.payload?.status === 'done' || res.payload?.status === 'Record Updated Successfully') {
                    toast.success("Recipe Updated Successfully");
                    // Clear all data
                    setFormData({
                        createDate: getCurrentDateKolkata(),
                        recipeCode: "",
                        remarks: "",
                        partyShadeNo: "",
                        isActive: true
                    });
                    setTableData([
                        { id: 1, ProdConsRecipeDtlId: 0, processGroup: '', itemShort: '', item: '', itemSubGroup: '', subProcess: '', temp: '', gpm: '', weight: false, taka: false, mts: false, liq: false, multiplier: '', cost: '' }
                    ]);
                    setRangeId(null); setRangeVal("");
                    setGroupId(null); setGroupVal("");
                    setPartyId(null); setPartyVal("");
                    setStageId(null); setStageVal("");
                    setProcessId(null); setProcessVal("");

                    // Jump to List
                    navigate('/TreatmentList');
                } else {
                    toast.error("Failed to update recipe");
                }
            });
        } else {
            dispatch(ProdConsRecipeInsert(payload)).then((res) => {
                if (res.payload?.status === 'done' || res.payload?.status === 'Record Inserted Successfully') {
                    toast.success("Recipe Saved Successfully");
                } else {
                    toast.error("Failed to save recipe");
                }
            });
        }
    };

    const inputTdStyle = {
        background: isdark === 'light' ? '#fff' : '#1e293b',
        border: `1px solid ${isdark === 'light' ? '#cbd5e1' : '#475569'}`,
        borderRadius: '4px',
        width: '100%',
        minWidth: '80px',
        color: isdark === 'light' ? '#334155' : '#e2e8f0',
        padding: '6px 8px',
        outline: 'none',
        fontSize: '13px'
    };

    const selectTdStyle = {
        background: isdark === "light" ? iscolour?.Colour5 || '#f8f9fa' : iscolourDark?.Colour9 || '#1e293b',
        border: 'none',
        borderRadius: '8px',
        width: '100%',
        minWidth: '120px',
        color: isdark === "light" ? iscolour?.Coloured12 || '#334155' : "#fff",
        padding: '8px 12px',
        outline: 'none',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer'
    };

    const thStyle = {
        background: isdark === 'light' ? iscolour?.Colour4 || '#3b82f6' : iscolourDark?.Colour7 || '#1e293b',
        color: isdark === 'light' ? iscolour?.Colour9 || '#fff' : '#fff',
        padding: '10px 8px',
        fontWeight: '600',
        fontSize: '13px',
        whiteSpace: 'nowrap',
        border: `1px solid ${isdark === 'light' ? '#e2e8f0' : '#334155'}`,
        position: 'sticky',
        top: 0,
        zIndex: 1
    };

    const tdStyle = {
        border: `1px solid ${isdark === 'light' ? '#e2e8f0' : '#334155'}`,
        padding: '6px 4px',
        verticalAlign: 'middle'
    };

    return (
        <div
            style={{
                background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10 || "#0f172a",
                minHeight: "100vh",
                padding: "16px",
            }}
        >
            <div
                style={{
                    background: isdark === "light" ? "#fff" : iscolourDark?.Colour10 || "#1e293b",
                    padding: "15px",
                    borderRadius: "12px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour6 || '#e2e8f0' : iscolourDark?.Colour7 || '#334155'}`,
                    marginBottom: "20px",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "20px",
                        paddingBottom: "12px",
                        borderBottom: `1px solid ${isdark === 'light' ? '#E5E7EB' : '#334155'}`,
                    }}
                >
                    <div
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: isdark === "light" ? iscolour?.Colour4 || '#3b82f6' : iscolourDark?.Colour7 || '#1e293b',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: isdark === "light" ? iscolour?.Colour9 || '#fff' : "#fff",
                            fontSize: "18px",
                            fontWeight: "600",
                        }}
                    >
                        ✦
                    </div>
                    <div>
                        <h6 style={{ margin: 0, fontWeight: "700", color: isdark === "light" ? iscolour?.Colour9 || '#1e293b' : "#f8fafc" }}>
                            Treatment
                        </h6>
                        <small style={{ color: "#8B95A7", fontSize: "13px" }}>
                            Manage recipe configuration and parameters
                        </small>
                    </div>
                </div>

                <Row className="g-3">
                    <Col xs={12}>
                        <Row className="g-3">
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Input label="Create Date" type="date" value={formData.createDate} onChange={(e) => handleInputChange('createDate', e.target.value)} isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Input label="Recipe Code" type="text" placeholder="Enter Code" value={formData.recipeCode} onChange={(e) => handleInputChange('recipeCode', e.target.value)} isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <MillstageDropDownFilter label="Range" data={rangeList} selectedValue={rangeVal} setSelectedValue={setRangeVal} selectedId={rangeId} setSelectedId={setRangeId} isMulti={false} placeholder="Select Range" isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <MillstageDropDownFilter label="Group" data={groupList} selectedValue={groupVal} setSelectedValue={setGroupVal} selectedId={groupId} setSelectedId={setGroupId} isMulti={false} placeholder="Select Group" isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>

                            <Col xs={12} sm={6} md={4} lg={3}>
                                <MillstageDropDownFilter label="Party" data={partyList} selectedValue={partyVal} setSelectedValue={setPartyVal} selectedId={partyId} setSelectedId={setPartyId} isMulti={false} disabled={!groupId} placeholder="Select Party" isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <MillstageDropDownFilter label="Stage Type" data={stageTypeList} selectedValue={stageVal} setSelectedValue={setStageVal} selectedId={stageId} setSelectedId={setStageId} isMulti={false} placeholder="Select Stage Type" isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <MillstageDropDownFilter label="Process" data={processList} selectedValue={processVal} setSelectedValue={setProcessVal} selectedId={processId} setSelectedId={setProcessId} isMulti={false} disabled={!stageId} placeholder="Select Process" isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>

                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Input label="Remarks" type="text" placeholder="Enter Remarks" value={formData.remarks} onChange={(e) => handleInputChange('remarks', e.target.value)} isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Input label="Party Shade No" type="text" placeholder="Shade No" value={formData.partyShadeNo} onChange={(e) => handleInputChange('partyShadeNo', e.target.value)} isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3} className="d-flex align-items-center mt-4">
                                <Input type="checkbox" label="Is Active" checked={formData.isActive} onChange={(e) => handleInputChange('isActive', e.target.checked)} isdark={isdark} iscolour={iscolour} iscolourDark={iscolourDark} />
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </div>

            {/* Bottom Section with Editable Table */}
            <div
                style={{
                    background: isdark === "light" ? "#fff" : iscolourDark?.Colour10 || "#1e293b",
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: `1px solid ${isdark === "light" ? iscolour?.Colour6 || '#e2e8f0' : iscolourDark?.Colour8 || '#334155'}`,
                }}
            >
                <div
                    style={{
                        padding: "15px 20px",
                        borderBottom: `1px solid ${isdark === "light" ? iscolour?.Colour6 || '#e2e8f0' : iscolourDark?.Colour8 || '#334155'}`,
                        background: isdark === "light" ? iscolour?.Colour6 || '#f1f5f9' : iscolourDark?.Colour8 || '#1e293b',
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <h6
                        style={{
                            margin: 0,
                            color: isdark === "light" ? iscolour?.Colour9 || '#0f172a' : "#fff",
                            fontWeight: "600",
                            borderBottom: `2px solid ${isdark === "light" ? iscolour?.Colour9 || '#0f172a' : "#fff"}`,
                            paddingBottom: '4px'
                        }}
                    >
                        Details
                    </h6>
                    <button
                        onClick={addRow}
                        style={{
                            padding: "6px 12px",
                            backgroundColor: isdark === "light" ? iscolour?.Colour8 || '#3b82f6' : iscolourDark?.Colour4 || '#2563eb',
                            color: isdark === "light" ? iscolour?.Colour1 || '#fff' : iscolourDark?.Colour1 || '#fff',
                            border: "none",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600"
                        }}
                    >
                        + Add Row
                    </button>
                </div>

                <div style={{ overflowX: "auto", maxHeight: "400px" }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                        <thead>
                            <tr>
                                <th style={{ ...thStyle, width: '40px' }}>#</th>
                                <th style={thStyle}>Process Group</th>
                                <th style={thStyle}>Item Short</th>
                                <th style={thStyle}>Item</th>
                                <th style={thStyle}>Item Sub Group</th>
                                <th style={thStyle}>Sub Process</th>
                                <th style={thStyle}>Temp / Hold Time</th>
                                <th style={thStyle}>GPM</th>
                                <th style={thStyle}>Weight</th>
                                <th style={thStyle}>Taka</th>
                                <th style={thStyle}>Mts</th>
                                <th style={thStyle}>LIQ</th>
                                <th style={thStyle}>Multiplier</th>
                                <th style={thStyle}>Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, index) => {
                                const selectedItemObj = AllFilterdata?.Item?.find(i => String(i.ItemId) === String(row.item));
                                const readOnlySubGroup = selectedItemObj?.ItemName || "";

                                return (
                                    <tr key={row.id} style={{ background: index % 2 === 0 ? (isdark === 'light' ? '#fff' : '#1e293b') : (isdark === 'light' ? '#f8fafc' : '#0f172a') }}>
                                        <td style={tdStyle}>
                                            <button
                                                onClick={() => deleteRow(row.id)}
                                                style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontWeight: 'bold' }}
                                            >
                                                ✕
                                            </button>
                                        </td>
                                        <td style={tdStyle}>
                                            <select style={selectTdStyle} value={row.processGroup} onChange={(e) => handleTableChange(row.id, 'processGroup', e.target.value)}>
                                                <option value="">Select Group</option>
                                                {AllFilterdata?.ProcessGrp?.map(item => (
                                                    <option key={item.ItemProcessGroupId} value={item.ItemProcessGroupId}>
                                                        {item.ItemProcessGroupName || item.ItemProcessGroupId}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td style={tdStyle}>
                                            <select style={selectTdStyle} value={row.itemShort} onChange={(e) => handleTableChange(row.id, 'itemShort', e.target.value)}>
                                                <option value="">Select Item Short</option>
                                                {AllFilterdata?.Item?.map(item => (
                                                    <option key={item.ItemId} value={item.ItemId}>
                                                        {item._I_CODE}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td style={tdStyle}>
                                            <select style={selectTdStyle} value={row.item} onChange={(e) => handleTableChange(row.id, 'item', e.target.value)}>
                                                <option value="">Select Item</option>
                                                {AllFilterdata?.Item?.map(item => (
                                                    <option key={item.ItemId} value={item.ItemId}>
                                                        {item.ItemName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td style={tdStyle}>
                                            <input
                                                type="text"
                                                style={{ ...inputTdStyle, background: isdark === 'light' ? '#f1f5f9' : '#334155', color: isdark === 'light' ? '#64748b' : '#94a3b8', cursor: 'not-allowed' }}
                                                value={readOnlySubGroup}
                                                readOnly
                                                placeholder="Sub Group"
                                            />
                                        </td>
                                        <td style={tdStyle}>
                                            <select style={selectTdStyle} value={row.subProcess} onChange={(e) => handleTableChange(row.id, 'subProcess', e.target.value)}>
                                                <option value="">Select Sub Process</option>
                                                {AllFilterdata?.RecipeSubProcess?.map(item => (
                                                    <option key={item.RecipeSubProcessID} value={item.RecipeSubProcessID}>
                                                        {item.RecipeSubProcessName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td style={tdStyle}><input type="text" style={inputTdStyle} value={row.temp} onChange={(e) => handleTableChange(row.id, 'temp', e.target.value)} /></td>
                                        <td style={tdStyle}><input type="text" style={inputTdStyle} value={row.gpm} onChange={(e) => handleTableChange(row.id, 'gpm', e.target.value)} /></td>
                                        <td style={tdStyle}><input type="checkbox" checked={row.weight} onChange={(e) => handleTableChange(row.id, 'weight', e.target.checked)} /></td>
                                        <td style={tdStyle}><input type="checkbox" checked={row.taka} onChange={(e) => handleTableChange(row.id, 'taka', e.target.checked)} /></td>
                                        <td style={tdStyle}><input type="checkbox" checked={row.mts} onChange={(e) => handleTableChange(row.id, 'mts', e.target.checked)} /></td>
                                        <td style={tdStyle}><input type="checkbox" checked={row.liq} onChange={(e) => handleTableChange(row.id, 'liq', e.target.checked)} /></td>
                                        <td style={tdStyle}><input type="text" style={inputTdStyle} value={row.multiplier} onChange={(e) => handleTableChange(row.id, 'multiplier', e.target.value)} /></td>
                                        <td style={tdStyle}>
                                            <input
                                                type="text"
                                                style={{ ...inputTdStyle, background: isdark === 'light' ? '#f1f5f9' : '#334155', color: isdark === 'light' ? '#64748b' : '#94a3b8', cursor: 'not-allowed' }}
                                                value={
                                                    (parseFloat(row.gpm) > 0 && selectedItemObj?.ItemRate1)
                                                        ? ((parseFloat(selectedItemObj.ItemRate1) / 1000) * parseFloat(row.gpm)).toFixed(2)
                                                        : ''
                                                }
                                                readOnly
                                                placeholder="Cost"
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Submit Button */}
            <div className="d-flex justify-content-end mt-4" style={{ paddingRight: "5px" }}>
                <button
                    onClick={handleSave}
                    style={{
                        padding: "10px 24px",
                        backgroundColor: isdark === "light" ? iscolour?.Colour8 || '#3b82f6' : iscolourDark?.Colour4 || '#2563eb',
                        color: isdark === "light" ? iscolour?.Colour1 || '#fff' : iscolourDark?.Colour1 || '#fff',
                        borderRadius: "8px",
                        fontWeight: "600",
                        border: "none",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                >
                    {editId ? 'Update Recipe' : 'Save Recipe'}
                </button>
            </div>

            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", color: isdark === "light" ? "#000" : "#fff", borderBottom: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: isdark === "light" ? "#fff" : "#0f172a", color: isdark === "light" ? "#333" : "#cbd5e1" }}>
                    Are you sure you want to {confirmAction} this recipe master?
                </Modal.Body>
                <Modal.Footer style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", borderTop: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={executeSave}
                    >
                        Yes, {confirmAction === 'update' ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Treatment;